import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Text from 'components/shared/Text';
import SVG from 'components/icons/SVG';
import { isNullish } from 'helpers/objects';
import styles from './styles.module.scss';

/*
 * Native Select for mobile devices
 */

function NativeSelect(props) {
  const [optionsElements, setOptionsElements] = useState([]);

  // Convert options to <option> elements
  useEffect(() => {
    const elements = Object.keys(props.options).map(value => (
      <option value={value} disabled={props.options[value].disabled} key={value}>
        {props.options[value].label ?? props.options[value]}
      </option>
    ));
    if (props.placeholder) {
      elements.unshift(
        <option value="" disabled key="placeholder">
          {props.placeholder}
        </option>
      );
    }
    setOptionsElements(elements);
  }, [props.options, props.placeholder]);

  return (
    <div className={classnames([styles.selectWrapper, ...props.wrapperStyles])}>
      <Text
        styles={[...props.labelStyles, styles.selectLabel, { [styles.selectedOption]: props.value }]}
        tag="label"
        htmlFor={props.id}>
        {props.name}
      </Text>
      <div className={classnames([styles.nativeSelectWrapper, props.nativeWrapperStyles])}>
        <select
          id={props.id}
          name={props.name}
          onChange={props.onChange}
          value={props.value ?? undefined}
          className={classnames([
            styles.select,
            styles.nativeSelect,
            { [styles.selectError]: props.error },
            { [styles.nativePlaceholder]: isNullish(props.value) || props.value === '' },
            ...props.inputStyles
          ])}>
          {optionsElements}
        </select>
        <SVG icon="arrowdown" styles={[styles.chevron, ...props.chevronStyles]} />
      </div>
      {props.error && !props.noErrorLabel && (
        <Text tag="p" styles={[styles.error]}>
          {props.error}
        </Text>
      )}
    </div>
  );
}

NativeSelect.propTypes = {
  options: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string, // eslint-disable-line
  error: PropTypes.string,
  noErrorLabel: PropTypes.bool,
  wrapperStyles: PropTypes.array,
  nativeWrapperStyles: PropTypes.array,
  labelStyles: PropTypes.array,
  inputStyles: PropTypes.array,
  chevronStyles: PropTypes.array
};

NativeSelect.defaultProps = {
  placeholder: undefined,
  value: undefined,
  error: undefined,
  noErrorLabel: undefined,
  wrapperStyles: [],
  nativeWrapperStyles: [],
  labelStyles: [],
  inputStyles: [],
  chevronStyles: []
};

export default NativeSelect;
